import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import React, { useEffect } from 'react';

interface FilterSectionProps {
  label: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export function FilterSection({ label, children, defaultOpen = true }: FilterSectionProps) {
  const [open, setOpen] = React.useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <section className='flex flex-col gap-4'>
      <button
        type='button'
        className='flex items-center justify-between w-full text-[18px] font-semibold focus:outline-none'
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={`section-${label}`}
      >
        {label}
        {open ? <ChevronUpIcon size={16} /> : <ChevronDownIcon size={16} />}
      </button>
      <div id={`section-${label}`} className={open ? '' : 'hidden'}>
        {children}
      </div>
    </section>
  );
}
